'use client';

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';

export interface FaqItem {
  question: string;
  answer: string;
}

export function FaqAccordion({ items }: { items: FaqItem[] }) {
  return (
    <Accordion type="single" collapsible className="w-full v4-lp-faq">
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          value={`faq-${i}`}
          className="v4-lp-faq__item"
        >
          <AccordionTrigger className="v4-lp-faq__trigger">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="v4-lp-faq__content">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
      <style>{`
        .v4-lp-faq__item {
          border: 1px solid var(--hair-2);
          border-radius: 14px;
          margin-bottom: 12px;
          overflow: hidden;
          background: rgba(244,244,240,0.02);
        }
        .v4-lp-faq__item:last-child { margin-bottom: 0; }
        .v4-lp-faq__item[data-state='open'] {
          border-color: rgba(125,250,255,0.35);
        }
        .v4-lp-faq__trigger {
          padding: 18px 22px;
          font-family: var(--font-geist-sans);
          font-size: 16px;
          font-weight: 500;
          color: var(--paper);
          letter-spacing: -0.01em;
        }
        .v4-lp-faq__trigger:hover {
          color: var(--cyan-glow);
        }
        .v4-lp-faq__content {
          padding: 0 22px 22px;
          color: var(--dim);
          font-family: var(--font-geist-sans);
          font-size: 15px;
          line-height: 1.6;
        }
      `}</style>
    </Accordion>
  );
}
